import { SupplementaryTaskType } from "api";
import { atom } from "recoil";

export const supplementaryTaskListAtom = atom<SupplementaryTaskType[]>({
  key: "supplementaryTaskList",
  default: [],
});
